import React from 'react';
import PropTypes from 'prop-types';

import PickingErrorToast from "./PickingErrorToast";
import {FormattedMessage} from "react-intl";
import PickingValidationToast from "./PickingValidationToast";

PickingToastManager.propTypes = {
    open: PropTypes.bool.isRequired,
    type: PropTypes.number,
    handleClose: PropTypes.func
};

export const ToastType = {
    TROLLEY_NOT_FOUND: 1,
    TROLLEY_ALREADY_TAKEN: 2,
    TROLLEY_CONTAIN_SHIPMENTS: 3,
    TASK_CREATED_SUCCESSFULLY: 4
}

function PickingToastManager({open = false, type = 0, handleClose = () => {}, isErrorToast = true}) {

    function getMessage() {
        switch (type) {
            case ToastType.TROLLEY_NOT_FOUND:
                return <FormattedMessage id='wms.myPickingMissions.scanTrolley.error.barcode.notValid' />
            case ToastType.TROLLEY_ALREADY_TAKEN:
                return <FormattedMessage id='wms.myPickingMissions.scanTrolley.error.trolley.alreadyTaken' />
            case ToastType.TROLLEY_CONTAIN_SHIPMENTS:
                return <FormattedMessage id='wms.myPickingMissions.scanTrolley.error.trolley.containShipments' />
            case ToastType.TASK_CREATED_SUCCESSFULLY:
                return <FormattedMessage id={'wms.myPickingMission.taskCreated'} />
            default:
                return null;
        }
    }
    if (isErrorToast) {
        return (
            <PickingErrorToast
                message={getMessage()}
                open={open}
                handleClose={handleClose}
            />
        )
    }

    return (
        <PickingValidationToast
            message={getMessage()}
            open={open}
            handleClose={handleClose}
        />
    )

}

export default PickingToastManager;
